import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/areas/useAreaQueryKeys.ts
var t = e("areas", {
	list: (e) => ["list", e],
	featured: () => ["featured"]
});
//#endregion
export { t as areaQueryKeys };
